import { IBooking } from '@/models/IBooking.model';
import { IPark, IParkWeekday, IParkWeekdays } from '@/models/IPark.model';
import { IUser } from '@/models/IUser.model';
import moment from 'moment';
export default function isDisabledDate(date: Date, park: IPark, bookings: IBooking[], user: IUser, clientType: string): boolean {

    // Variables
    const cc = (user as any).cc || user.cc_number;
    const weekdays = park.weekdays;
    const bookingsOnThisDDMMYYYY = bookings
    .filter(booking => booking.ddmmyyyy === moment(date).format('DDMMYYYY'))
    .filter(booking => booking.parkName === park.name);



    // PICO Y CEDULA
    if(cc){
        //const isPicoYCedula = checkPicoYCedula(date,cc);
        //if(isPicoYCedula) return true;
    }


    // WEEKDAYS Y HORARIOS
    if(weekdays){
        const isWeekdays = checkWeekdays(date, weekdays, clientType);
        if(isWeekdays) return true;
    }


    // USUARIO YA RESERVO ESE DIA
    if(user && bookings){
        const iBookedSameDate = checkUserBookedSameDay(date, user, bookingsOnThisDDMMYYYY)
        if(iBookedSameDate) return true;
    }


    // DIA ESTA FULL
    if(park && bookings){
        const iFullDate = checkIsFullDate(date, park, bookings)
        if(iFullDate) return true;
    }


    return false;
}

export function checkIsFullDate(date: Date, park: IPark,  bookings: IBooking[]): boolean{

    return false;
}

export function checkPicoYCedula(date: Date, cc: string): boolean{

    const ccLastChart = cc.slice(cc.length - 1);
    const dateIsPar = (date as Date).getDate() % 2 == 0;
    const ccIsPar = parseInt(ccLastChart + '', 10) % 2 == 0;

    if(!ccIsPar && !dateIsPar) return true;
    if(ccIsPar && dateIsPar) return true;

    return false;
}


export function checkUserBookedSameDay(date: Date, user: IUser, bookings: IBooking[]): boolean{
    const cc = ((user as any).cc || user.cc_number);
    const bookingsForSameUser = bookings.filter((booking:IBooking) => 
        (booking.cc_number + '') === (cc + '')
    );
    if(bookingsForSameUser && bookingsForSameUser.length > 0){   
            const bookingsForSameDate = bookingsForSameUser.filter((booking:IBooking) => 
            moment(date).isSame(moment(booking.date), 'date') &&
            moment(date).isSame(moment(booking.date), 'month') && 
            moment(date).isSame(moment(booking.date), 'year') 
        );
        if(bookingsForSameDate.length > 0)  return true;  
    }
    return false;
}

export function checkWeekdays(date: Date, weekdays: IParkWeekdays,clientType: string): boolean{

    const dayOfTheWeek = date.getDay() + 0;

    const isMondayAviable = weekdays.monday.length > 0 && weekdays.monday
        .filter(weekday => weekday.aviableFor.includes(clientType as any)).length > 0;
    const isTusdayAviable = weekdays.tuesday.length > 0 && weekdays.tuesday
        .filter(weekday => weekday.aviableFor.includes(clientType as any)).length > 0;
    const isWednesdayAviable = weekdays.wednesday.length > 0 && weekdays.wednesday
        .filter(weekday => weekday.aviableFor.includes(clientType as any)).length > 0;
    const isThursdayAviable = weekdays.thursday.length > 0 && weekdays.thursday
        .filter(weekday => weekday.aviableFor.includes(clientType as any)).length > 0;
    const isFridayAviable = weekdays.friday.length > 0 && weekdays.friday
        .filter(weekday => weekday.aviableFor.includes(clientType as any)).length > 0;
    const isSaturdayAviable = weekdays.saturday.length > 0 && weekdays
        .saturday.filter(weekday => weekday.aviableFor.includes(clientType as any)).length > 0;
    const isSundayAviable = weekdays.sunday.length > 0 && weekdays
        .sunday.filter(weekday => weekday.aviableFor.includes(clientType as any)).length > 0;

    // DIAS DISPONIBLES
    if(dayOfTheWeek === 1 && !isMondayAviable) return true;
    if(dayOfTheWeek === 2 && !isTusdayAviable) return true;
    if(dayOfTheWeek === 3 && !isWednesdayAviable) return true;
    if(dayOfTheWeek === 4 && !isThursdayAviable) return true;
    if(dayOfTheWeek === 5 && !isFridayAviable) return true;
    if(dayOfTheWeek === 6 && !isSaturdayAviable) return true;
    if(dayOfTheWeek === 0 && !isSundayAviable) return true;

    return false;
}